import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../models/user';
import { UsersService } from '../users.service';
import { ParamMap, Router } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityDetailsPageComponent } from '../../util/entity-details-page.component';
import { UnauthorizedError } from '../../util/http.service';
import { EntityDetailsPageService } from 'src/app/util/entity-details-page.service';
import { ActionConfirmationService } from 'src/app/util/confirmation/confirmation.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  providers: [EntityDetailsPageService],
})
export class UserDetailsComponent
  extends EntityDetailsPageComponent<User>
  implements OnInit, OnDestroy
{
  unauthorized_delete = false;

  baseTitle = 'User Details';

  constructor(
    private router: Router,
    private usersService: UsersService,
    detailsService: EntityDetailsPageService<User>,
    dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { id: string }
  ) {
    super(detailsService, usersService, new ActionConfirmationService(dialog));
  }

  confirmDeleteUser(user: User) {
    this.confirmAction(
      `Are you sure you want to delete user '${user.name}'?`,
      () => this.usersService.deleteEntity(user),
      () => {
        this.eventsService.pushEvent({
          message: `User ${user.name} deleted`,
          status: 'success',
        });
        this.router.navigate(['/organization', 'users']);
      },
      (error: Error) =>
        (this.unauthorized_delete = error instanceof UnauthorizedError)
    );
  }

  getTitle(user: User): string {
    return user.name;
  }

  loadEntity(params: ParamMap): Observable<User> {
    return this.usersService.getEntity(this.data.id);
  }
}
